import React, { useEffect, useRef, useState } from "react";
import { eyeGet, eyeFrameBlob } from "../../lib/api";

const IntruderFeed = ({ userId }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let stop = false, url = null;
    const pull = async () => {
      try { const b = await eyeFrameBlob(userId); const u = URL.createObjectURL(b); if (url) URL.revokeObjectURL(url); url = u; setSrc(u); } catch (e) {}
      if (!stop) setTimeout(pull, 1000);
    };
    pull();
    return () => { stop = true; if (url) URL.revokeObjectURL(url); };
  }, [userId]);
  return (
    <div className="fixed inset-0 z-[60] bg-black flex items-center justify-center nx-intruder pointer-events-none" data-testid="tv-eye-intruder-wall">
      {src && <img src={src} alt="intruder live" className="absolute inset-0 w-full h-full object-cover -scale-x-100 opacity-75 nx-intruder-feed" data-testid="tv-eye-intruder-feed" />}
      <div className="absolute inset-0 border-[18px] border-rose-600 animate-pulse" />
      <div className="relative text-center">
        <p className="nx-orbitron text-[clamp(4rem,10vw,10rem)] font-black tracking-widest text-rose-500 nx-glitch">INTRUDER</p>
        <p className="text-[clamp(1.5rem,3vw,3rem)] font-black text-rose-100">YOU ARE ON CAMERA. YOUR FACE HAS BEEN SENT TO THE OWNER.</p>
        <p className="nx-mono text-rose-300 mt-4 text-xl animate-pulse">● REC · LEAVE NOW</p>
      </div>
    </div>
  );
};

export const TvEyeAlert = ({ userId, wallOnly = false }) => {
  const [alarm, setAlarm] = useState(false);
  const [banner, setBanner] = useState(null);
  const last = useRef(null);
  useEffect(() => {
    let stop = false;
    const poll = async () => {
      try {
        const d = await eyeGet(userId);
        setAlarm(!!d.alarm);
        const ev = d.event;
        if (ev && ev.id !== last.current) {
          const fresh = last.current !== null && Date.now() / 1000 - ev.ts < 30;
          last.current = ev.id;
          if (fresh && ev.kind !== "business") {
            setBanner(ev);
            setTimeout(() => setBanner(null), ev.kind === "intruder" ? 20000 : 10000);
          }
        }
      } catch (e) {}
      if (!stop) setTimeout(poll, 500);
    };
    poll();
    return () => { stop = true; };
  }, [userId]);
  return (
    <>
      {banner && !wallOnly && (
        <div className={`fixed inset-x-0 top-24 z-50 flex justify-center pointer-events-none ${banner.kind === "intruder" ? "animate-pulse" : ""}`} data-testid={`tv-b-eye-banner-${banner.kind}`}>
          <div className={`rounded-3xl px-12 py-6 text-center border-4 max-w-[90vw] ${banner.kind === "intruder" || banner.kind === "health" ? "bg-rose-950/95 border-rose-500 text-rose-100" : "bg-emerald-950/95 border-emerald-400 text-emerald-100"}`}>
            <p className="nx-orbitron text-[clamp(2rem,4vw,4rem)] font-black tracking-widest">{banner.kind === "intruder" ? "INTRUDER" : banner.kind === "health" ? "HEALTH CHECK" : banner.kind === "gesture" ? "NEXUS" : `WELCOME, ${(banner.name || "").toUpperCase()}`}</p>
            <p className="mt-3 text-[clamp(1rem,1.6vw,1.5rem)] line-clamp-3">{banner.text}</p>
          </div>
        </div>
      )}
      {alarm && <div className="fixed inset-0 z-[45] pointer-events-none border-[12px] border-rose-600 animate-pulse" data-testid="tv-b-eye-alarm-frame" />}
      {alarm && <IntruderFeed userId={userId} />}
    </>
  );
};
